export const zIndex = /** @type {const} */ ({
  port: 1,
  portOvernight: 2,
  portStart: 3,
  portCurrent: 4,
  portInfo: 5,
  riverPath: 1,
  riverArrowPath: 2,
  oceanPath: 3,
  examplePath: 4,
  airplanePath: 5,
});
